module.exports = __webpack_public_path__ + "media/water-bader.25ff1ded.mp4";